
import { PlusCircle, MinusCircle } from 'feather-icons-react/build/IconComponents';
import React, { useState, useEffect, useRef } from 'react'
// import { Link } from 'react-router-dom'
import Select from 'react-select'
import axios from "axios";
import { set_store_list, set_supplier_list, set_product_list, set_page_refresh} from "../../redux/action";
// import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

const AddPurchases = () => {
    // const navigate = useNavigate();
    const dispatch = useDispatch();
    const tenantId = localStorage.getItem("tenantId") || null;
    const l = useSelector((state) => state.language || "en");
    const t = useSelector((state) => state.translation || "en");
    // const defaultSelect = {label: choose, value: "choose"};
    const choose = t?.[l]?.["choose"] || "Choose"

        const categoryList = useSelector((state) => state.category_list || []);
        const filteredCategories = categoryList
          .filter((itm) => itm.tenantid == ((tenantId === "n4Xc96g6qyNcrq5dD"  || tenantId ===  "jNrhXAynhAbQkrj8Y" || tenantId == "8wNWEtTEdgoywriNX" ) ? tenantId : null))
          .map((itm) => ({
            label: t?.[l]?.[itm._id] || itm.name,
            value: itm._id
          }));
        
        const category = [{ label: choose, value: "choose" }, ...filteredCategories];
    

   // const category = useSelector((state) => [{label: choose, value: "choose"}].concat(state.category_list?.map((itm) => { return {label: itm.name, value: itm._id}})));
    const supplier = useSelector((state) => [{label: choose, value: "choose"}].concat(state.supplier_list?.map((itm) => { return {label: itm.name, value: itm._id}})));
    
    const store = useSelector((state) => [{label: choose, value: "choose"}].concat(state.store_list?.map((itm) => { return {label: itm.name, value: itm._id}})));
    const allProducts= useSelector((state) => state.product_list);
    const [productsList, setProductsList] = useState([{label: choose, value: "choose"}]);
    const [variants, setVariants] = useState([{label: choose, value: "choose"}]);
    const [productFilterList, setProductFilterList] = useState([])
    
    const purchaseData = useSelector((state) => state.purchase_edit)
    const [purchase, setPurchase] = useState({})
    const [product, setProduct] = useState([])
    const [grossTotal, setGrossTotal] = useState([])
    const [grossCount, setGrossCount] = useState([])
    const [purchaseStatus, setPurchaseStatus] = useState([])
    const [selectedCategoryId, setSelectedCategoryId] = useState([])
    const [selectedStoreID, setselectedStoreID] = useState([])

    
    const closeRef = useRef(null)

    const status = [
        { value: 'choose', label: choose },
        { value: 'pending', label: t?.[l]?.["pending"] || 'Pending' },
        { value: 'received', label: t?.[l]?.["received"] || 'Received' },
    ];
    
  const getStoreApi = async () => {
    // const res = await APIgetStores({});
    // if (res?.response?.stores) {
        const storeOptionsList = localStorage.getItem('storeOptionsList');
        const storeOption = JSON.parse(storeOptionsList);
        
        console.log("storeOption",storeOption);
        // if (storeOptionsList) {
        //   setStoreList(JSON.parse(storeOptionsList));
        // }
    //   const storeData = res.response.stores.reverse();
    //   const storeOptions = storeOption.map((store) => (
    //     if(store.value !="")
    //     {
    //     {
    //     name: store.label, // storeNumber
    //     _id: store.value
    //   }}
    // ));
    const storeOptions = storeOption
    .filter(store => store.value !== "") // Filter out stores with an empty value
    .map(store => ({
        name: store.label, // storeNumber
        _id: store.value,
    }));

      dispatch(set_store_list(storeOptions));
     // setDataStore(storeOptions);
    // }
  };
    useEffect(() => {
        async function fetchData() {
            // axios.get('getusercategories/', {}).then((res) => {
            //     dispatch(set_category_list(res.data))
            // })
        
            getStoreApi();
            axios.get('getusersuppliers/', {}).then((res) => {
                dispatch(set_supplier_list(res.data))
            })
            if(tenantId && tenantId == "n4Xc96g6qyNcrq5dD" || tenantId == "jNrhXAynhAbQkrj8Y" || tenantId == "8wNWEtTEdgoywriNX")
            {
                console.log("tenantIdtenantId-1",tenantId)
                axios.get('getuserproducts/?tenantId='+tenantId, {}).then((res) => {
                    const resData = res.data.filter((itm) => itm.generalProductType !== "bid")
                    dispatch(set_product_list(resData))
                })
            }
            else
            {
                console.log("tenantIdtenantId-2",tenantId)
                axios.get('getuserproducts/', {}).then((res) => {
                    const resData = res.data.filter((itm) => itm.generalProductType !== "bid")
                    dispatch(set_product_list(resData))
                })
            }
        }
        fetchData()
    }, [])


    useEffect(() => {
        let p2 = purchase.products
        setGrossTotal(p2?.reduce((a, s) => a + s.totalCost, 0) || 0)
        setGrossCount(p2?.reduce((a, s) => a + Number(s.qty), 0) || 0)
        const filteredProducts = productFilterList?.filter(itm => itm.productType !== "custom") || [];

        setProductsList([{label: choose, value: "choose"}].concat(filteredProducts?.map((itm) => { return {label: `${itm.name}${itm.brandName ? ` (${itm.brandName})` : ''}`, value: itm._id, unitPrice: itm.price, attribute: itm.attribute}})))
       
    }, [purchase, productFilterList])

    const addItemForPurchase = () => {
        const { storeId, productId, categoryId, qty, attributeValue } = product || {};
        const isRequiredFieldMissing = [storeId, productId, categoryId].includes("choose") || !storeId || !productId || !categoryId;
        const isInvalidQuantity = qty <= 0;
        if(!qty)
        {
            alert(t?.[l]?.["please_fill_all_required_fields"] || "Please fill all required fields correctly");  
        }
        // isDisabled={(variants.length === 1 && variants[0].value === "choose")}

        // else if (isRequiredFieldMissing || isInvalidQuantity
        //      || (variants?.length <= 1 && attributeValue == null )
        //      ||  (variants?.length >= 2 && attributeValue == "choose" )) {
            else if (isRequiredFieldMissing || isInvalidQuantity
                || (variants?.length >= 1 && (attributeValue == null || attributeValue == undefined))) {
  //  eslint-disable-next-line no-debugger
            debugger;
            alert(t?.[l]?.["please_fill_all_required_fields"] || "Please fill all required fields correctly");
        }

        else if(variants?.length>1 &&  !product.attributeValue) 
        {
            console.log('check error');
        }
        else
        {
            if(variants?.length<=1)
                if(product.attributeValue)
                    delete product.attributeValue;

            const tPr = JSON.parse(JSON.stringify(allProducts.filter((itm) => product.productId == itm._id)[0] || {}))
            let sId = product.storeId;
            let sName = product.storeName;
            let exist = purchase?.products?.filter((itm) => itm.storeId == sId && itm.p_id == product.productId && itm.attributeValue == product.attributeValue);
    
            if(exist?.length) {
                let aP = purchase.products.map((itm) => {
                    if(itm.p_id == product.productId) {
                        itm.qty = Number(itm.qty) + Number(product.qty);
                        itm.totalCost = (Number(itm.qty) || 0) * (Number(itm.unitPrice) || 0)
                        
                    }
                    return itm;
                })
                setPurchase(prevState => {
                    return ({
                        ...prevState,
                        ["products"]: JSON.parse(JSON.stringify(aP))
                    })
                });
                
            } else {
                tPr.qty = Number(product.qty);
                tPr.unitPrice = product.unitPrice;
                tPr.totalCost = (Number(product.qty) || 0) * (Number(product.unitPrice) || 0)
                tPr.attributeValue = product.attributeValue;
                setPurchase(prevState => {
                    let p2 = purchase.products
                    if(!p2) {
                        p2 = [] 
                    }
                    tPr.storeId = sId
                    tPr.storeName = sName
                    p2.push(JSON.parse(JSON.stringify(tPr)))
                    return ({
                        ...prevState,
                        ["products"]: p2
                    })
                });

            }
            delete product.attributeValue;
        }
    }
    const removeItemForPurchase = (ind) => {
        
        setPurchase(prevState => {

            let p2 = purchase.products
            if(p2.length) {
                p2.splice(ind, 1)
            }
            return ({
                ...prevState,
                ["products"]: p2
            })
        });
    }
    
    useEffect(() => {
        if(Object.keys(purchaseData || {}).length) {
            let data = JSON.parse(JSON.stringify(purchaseData))
            if(typeof data.products == "string"){
                data.products = JSON.parse(data.products)
            }
            Object.keys(data).forEach((k) => {
                setPurchase((prevState) => ({...prevState, [k]: data[k]}))
            })
            setGrossTotal(purchaseData.grossTotal)
            setGrossCount(purchaseData.grossCount)
            setPurchaseStatus(data.purchaseStatus)
        } else {
            setPurchase({})
            setPurchaseStatus("")
            setProduct([])
            setGrossTotal(0)
            setGrossCount(0)
        }
        // setTimeout(setProductFilterList, 1000, allProducts)
    }, [purchaseData])
    const submit= async (event) => {
        const form = event.currentTarget;
        
        event.preventDefault()
        event.stopPropagation()
        try {
            if(!purchase?.products?.length ||purchase?.products?.length ==0)
            {
                alert(t?.[l]?.["please_add_products_with_quantity"] || "Please add products with quantity.");
                return;
            }
        if(form?.checkValidity() && purchase?.products?.length) {
      //To Do have to delete productAttributes object
  //  eslint-disable-next-line no-debugger
  debugger;
            purchase?.products.forEach(product => {
                if (product?.productAttributes) {
                    delete product.productAttributes;
                }
            });

            await axios.post('addpurchase/', {
                grossCount, grossTotal, purchaseStatus, products: purchase?.products, _id: purchase._id
            });
            dispatch(set_page_refresh("purchaselist"))
            closeRef.current?.click()
            document.querySelector(".modal-backdrop").classList.toggle("show")
        }
        } catch(e) {
            console.log(e)
            return false;
        }
        

        return false;
    }
    const formatVariant = (attributes) => {
        return attributes.map(attr => Object.values(attr)).join('|');
    };
    const handleProductChange = (e) => {
        const { name, value } = e.target;
        setProduct((prevState) => ({
            ...prevState,
            [name]: value,
        }));
          //  eslint-disable-next-line no-debugger
debugger;
        if (name === "attributeValue") {
               //  eslint-disable-next-line no-debugger
     debugger;
            const selectedProduct = allProducts.find(p => p._id === product.productId);
             if ( selectedProduct.productAttributes) {//productId
                //formatVariant value
                const res = selectedProduct.productAttributes.find(p => formatVariant(p.attributes) == value)
                console.log('test');
                  //  eslint-disable-next-line no-debugger
     debugger;
     if(res)
                setProduct((prevState) => ({
                    ...prevState,
                    unitPrice: res.price,  // Resetting Unit Price to attr.price
                }));
         }
    }

        if (name === "productId") {
            const selectedProduct = allProducts.find(p => p._id === value);
            if (selectedProduct && selectedProduct.productAttributes) {
                const variantOptions = selectedProduct.productAttributes.map((attr) => ({
                    label: formatVariant(attr.attributes),
                    value: formatVariant(attr.attributes),
                }));
                setVariants(variantOptions);
            } else {
                setVariants([{ label: choose, value: "choose" }]);
            }
        }

        if (name === "categoryId") {
            setSelectedCategoryId(value);
    
            let filtered = allProducts;
             if (value && selectedStoreID) {
                filtered = filtered.filter(
                    (a) => a.categoryId === value && a.storeId === selectedStoreID
                );
            }
    
            setProductFilterList(filtered);
        }
    
        if (name === "storeId") {
            setselectedStoreID(value);
    
            let filtered = allProducts;
            // Use value (the latest storeId) and selectedCategoryId
            if (value && selectedCategoryId) {
                filtered = filtered.filter(
                    (a) => a.storeId === value && a.categoryId === selectedCategoryId
                );
            }
            setProductFilterList(filtered);
        }
    };
    
    // const handleProductChange = (e) => {
    //     const { name, value } = e.target;
    //     setProduct(prevState => ({
    //         ...prevState,
    //         [name]: value
    //     }));
    //     if(name == "categoryId") {
    //         setSelectedCategoryId(value);
        
    //         let filtered = allProducts;
    //         if(product.categoryId && selectedStoreID) {
    //             filtered = filtered.filter((a) => a.categoryId == value && a.storeId == selectedStoreID)
    //         }

    //         setProductFilterList(filtered)
    //     }
        
    //     if(name == "storeId") {
    //         setselectedStoreID(value)

    //         let filtered = allProducts;
    //         if(product.storeId && selectedCategoryId) {
    //             filtered = filtered.filter((a) => a.storeId == value && a.categoryId == selectedCategoryId )
    //         }
    //         setProductFilterList(filtered)
    //     }

    // };

    return (
        <div>
            {/* Add Purchase */}
            <div className="modal fade" id="add-units">
                <div className="modal-dialog purchase modal-dialog-centered stock-adjust-modal">
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title">
                                        <h4>{Object.keys(purchaseData || {}).length > 0 ? t?.[l]?.["edit_purchase"] || "Edit Purchase" : t?.[l]?.["add_purchase"] || "Add Purchase"}</h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        ref={closeRef}
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body custom-modal-body">
                                    
                                <form>
                                    <div className={`row ${Object.keys(purchaseData || {}).length ? "hidden" : ""}`}>
                                            <div className="col-lg-3 col-md-3 col-sm-12">
                                                <div className="input-blocks add-product">
                                                    <label>{t?.[l]?.["store"] || "Store"} *</label>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            

                                                            <Select 
                                                            className="select"
                                                            options={store}
                                                            placeholder={choose}
                                                           
                                                            required
                                                            value = {
                                                                [store?.filter(option => 
                                                                    option?.value === product?.storeId).concat(store.filter(option => 
                                                                        option?.value === "choose"))[0]]
                                                                
                                                            }
                                                            onChange={(v) => {
                                                                handleProductChange({target: {name: "storeId", value: v.value}})
                                                                handleProductChange({target: {name: "storeName", value: v.label}})
                                                            }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-12">
                                                <div className="input-blocks add-product">
                                                    <label>{t?.[l]?.["supplier_name"] || "Supplier Name"}</label>
                                                    <div className="row">
                                                        <div className="col-12">

                                                            <Select 
                                                            className="select"
                                                            options={supplier}
                                                            placeholder={choose}
                                                            name="supplier"
                                                            required 
                                                            value = {
                                                                [supplier?.filter(option => 
                                                                    option?.value === product?.supplierId).concat(supplier.filter(option => 
                                                                        option?.value === "choose"))[0]]
                                                                
                                                            }
                                                            onChange={(v) => {
                                                                handleProductChange({target: {name: "supplierId", value: v.value}})
                                                                handleProductChange({target: {name: "supplierName", value: v.label}})
                                                            }} />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-12">
                                                <div className="input-blocks">
                                                    <label>{t?.[l]?.["category_name"] || "Category Name"} *</label>
                                                    
                                                    <Select 
                                                    className="select"
                                                    options={category}
                                                    placeholder={choose}
                                                    name="category" 
                                                    required
                                                    value = {
                                                        [category?.filter(option => 
                                                            option?.value === product?.categoryId).concat(category.filter(option => 
                                                                option?.value === "choose"))[0]]
                                                        
                                                    }
                                                    onChange={(v) => {
                                                        handleProductChange({target: {name: "categoryId", value: v.value}})
                                                        handleProductChange({target: {name: "categoryName", value: v.label}})
                                                    }} />

                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-12">
                                                <div className="input-blocks">
                                                    <label>{t?.[l]?.["product_name"] || "Product Name"}*</label>
                                                    
                                                    <Select 
                                                    className="select"
                                                    options={productsList}
                                                    placeholder={choose}
                                                    name="productsList" 
                                                    required
                                                    value = {
                                                        [productsList?.filter(option => 
                                                            option?.value === product?.productId).concat(productsList.filter(option => 
                                                                option?.value === "choose"))[0]]
                                                        
                                                    }
                                                    onChange={(v) => {
                                                        setVariants([{label: choose, value: "choose"}].concat(v?.attribute || []))
                                                        handleProductChange({target: {name: "productId", value: v.value}})
                                                        handleProductChange({target: {name: "productName", value: v.label}})
                                                        handleProductChange({target: {name: "unitPrice", value: v.unitPrice}})
                                                    }} />

                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-12">
                                                <div className="input-blocks tab">
                                                    
                                                    <label>{t?.[l]?.["variant"] || "Variant"}</label>
                                                    <Select 
                                                    className="select"
                                                    options={variants}
                                                    placeholder={choose}
                                                    name="variants" 
                                                    isDisabled={(variants.length === 1 && variants[0].value === "choose")}

                                                    value = {
                                                        variants?.filter(option => 
                                                            option?.value === product?.attributeValue)
                                                        
                                                    }
                                                    onChange={(v) => {
                                                        handleProductChange({target: {name: "attributeValue", value: v.value}})
                                                    }} />
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-4 ">
                                                <div className="input-blocks">
                                                    <label>{t?.[l]?.["quantity"] || "Quantity"}</label>
                                                    <input type="number" className="form-control" required value={product?.qty || ""} name="qty" onChange={handleProductChange}/>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-12">
                                                <div className="input-blocks">
                                                    <label>{t?.[l]?.["unit_price"] || "Unit Price"}</label>
                                                    <input disabled type="text" className="form-control" value={product?.unitPrice || ""} required name="unitPrice" />
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-12">
                                                <div className="input-blocks add-icon tab">
                                                    <label>{t?.[l]?.["add"] || "Add"}</label>
                                                    <div onClick={addItemForPurchase}  style={{width:"40px",height: "40px",background: "#BC8F8F",display: "flex",alignItems: "center",justifyContent: "center",borderRadius: "5px"}}>
                                                        <PlusCircle className="feather-plus-circles" style={{color: "#ffffff"}}/>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                        </form>
                                        <form onSubmit={submit}> 
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="modal-body-table">
                                                    <div className="table-responsive">
                                                        <table className="table">
                                                            <thead>
                                                                <tr>
                                                                    <th></th>
                                                                    <th>{t?.[l]?.["product"] || "Product"}</th>
                                                                    <th>{t?.[l]?.["variation"] || "Variation"}</th>
                                                                    <th>{t?.[l]?.["quantity"] || "Quantity"}</th>
                                                                    <th>{t?.[l]?.["unit_cost"] || "Unit Cost"}</th>
                                                                    <th>{t?.[l]?.["total_cost"] || "Total Cost"}</th>
                                                                    <th className={`${Object.keys(purchaseData || {}).length ? "hidden" : ""}`}></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {purchase?.products?.map((p, i) => {
                                                                    return (
                                                                        <tr key={i}>
                                                                            <td>{i + 1}</td>
                                                                            <td className="">{p?.name}</td>
                                                                            <td className="">
                                                                                {p?.attributeValue ? p.attributeValue : (t?.[l]?.["not_specified"] || "Not Specified")}
                                                                            </td>

                                                                            <td className="">{p?.qty}</td>
                                                                            <td className="">{p.unitPrice}</td>
                                                                            <td className="">{p.totalCost}</td>
                                                                            <td className={`${Object.keys(purchaseData || {}).length ? "hidden" : ""}`}>
                                                                                <div className="col-lg-1 col-md-2 col-sm-4 ">
                                                                                    <div className="add-icon tab">
                                                                                        {/* <Link to="#" onClick={() => removeItemForPurchase(i)}>
                                                                                            <MinusCircle className="feather-plus-circles"/>
                                                                                        </Link> */}

                                                                                        <div onClick={() => removeItemForPurchase(i)} style={{width:"40px",height: "40px",background: "#BC8F8F",display: "flex",alignItems: "center",justifyContent: "center",borderRadius: "5px"}}>
                                                                                            <MinusCircle className="feather-plus-circles" style={{color: "#ffffff"}}/>
                                                                                        </div> 
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                                
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div className="row">
                                                <div className="col-lg-3 col-md-6 col-sm-12">
                                                    <div className="input-blocks">
                                                        <label>{t?.[l]?.["status"] || "Status"}</label>
                                                        <Select options={status} required className="select" placeholder={choose} 
                                                        
                                                        value = {
                                                            status?.filter(option => 
                                                            option?.value === purchaseStatus)
                                                        }
                                                        onChange={(v) => {
                                                            setPurchaseStatus(v.value)
                                                        }} />
                                                    

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-11">
                                                    <div className="input-blocks">
                                                        <label>{t?.[l]?.["item_count"] || "Item Count"}</label>

                                                    </div>
                                                </div>
                                                <div className="col-1">
                                                    <div className="input-blocks">
                                                        <label>{grossCount}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-11">
                                                    <div className="input-blocks">
                                                        <label>{t?.[l]?.["gross_total"] || "Gross Total"}</label>

                                                    </div>
                                                </div>
                                                <div className="col-1">
                                                    <div className="input-blocks">
                                                        <label>{grossTotal}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="modal-footer-btn">
                                                <button
                                                    type="button"
                                                    className="btn btn-cancel me-2"
                                                    data-bs-dismiss="modal"
                                                >
                                                    {t?.[l]?.["cancel"] || "Cancel"}
                                                </button>
                                                <button type="submit" className="btn btn-submit">
                                                    {t?.[l]?.["save"] || "Save"}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Add Purchase */}
        </div>
    )
}

export default AddPurchases
